import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import DashboardFooter from "../../../layoutcontainers/DashboardLayout/components/Footer"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialBox from "../../../components/MaterialBox"
import MaterialInput from "../../../components/MaterialInput"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react"
import MaterialButton from "../../../components/MaterialButton"
import MaterialSelect from "../../../components/MasterSelect"
import { useStateFormHandling } from "./components/StateStateHandle"
import { fetchData, fetchDataById, postData, putData } from "../../../services"
import { useSnackbar } from "../../../context/popup"
import { setCircleLoading } from "../../../components/Loading"

const StateForm = () => {

    const navigate = useNavigate();
    const {showSnackbar} = useSnackbar();
    const [countryDropdownOptions,setCountryDropdownOptions] = useState([]);
    const { formData, setFormData, handleChange, checkAllFields } = useStateFormHandling();
    const [searchParams] = useSearchParams();
    const stateId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" 
    ? "edit" : "add";

    useEffect(() => {
        //Dropdown API
        if(pageMode!=="view"){
            const fetchCountryList = async () => {
                try {
                const response = await fetchData(`/reference/general/country?dropdown=true&isActive=true`)                
                if(response?.success){
                    const formattedCountries = response?.data?.items?.map((item) => ({
                        value: item.id,
                        label: item.displayName,
                    }));

                    setCountryDropdownOptions(formattedCountries);                }
                else{
                    //throw error
                    showSnackbar("Error Fetching Country Dropdown", "error")
                }
                } catch (error) {
                console.error('Error Fetching Countries:', error);
                showSnackbar(error?.response?.data?.message || 'Error Fetching Countries', "error");
                }
            };
            fetchCountryList();
        }
        
    },[pageMode])

    //GET by Id Data return
    useEffect(() => {
        if(pageMode === "add"){
            return;
        }
        const fetchStateById = async (stateId) => {
        try {
            const response = await fetchDataById(`/reference/general/state/${stateId}`);
            const responseData = response?.data;
            if(response.success){
                setFormData(prev => ({
                ...prev,
                name: responseData.name || "",
                code: responseData.code || "",
                active: responseData.isActive,
                iplStateId: responseData.id || "",
                countryId: { value: responseData?.country?.name || "" , label : responseData?.country?.name || ""},
                // reset status fields
                nameStatus: responseData.name ? "success" : "unchecked",
                codeStatus: responseData.code ? "success" : "unchecked",
                iplStateIdStatus: responseData.id ? "success" : "unchecked",
                countryIdStatus: responseData?.country?.name ? "success" : "unchecked"
                }));
            }
            else{
                //throw error
            }
        } catch (error) {
            console.error('Error fetching data by ID:', error);
            showSnackbar(error?.response?.data?.message || 'Error fetching data by ID', "error");
        }
        };
        fetchStateById(stateId);
    },[pageMode]);

    const handleStateAction = async() => {
        const payload = { 
            countryId: formData?.countryId?.value,
            name: formData?.name, 
            code: formData?.code,
            isActive: formData?.active
        };
        //Update
        if(stateId){
            try {
                setCircleLoading(true);
                const response = await putData(`/reference/general/state/${stateId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/general-master/state-list');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || 'Error updating data', "error");
            }finally{
                setCircleLoading(false);
            }
        }
        else{      
        //Submit
        try {
            setCircleLoading(true);
            const response = await postData('/reference/general/state', payload);
            const responseMessage = response?.message;
            if(response?.success){
                //success message
                showSnackbar(responseMessage,"success");
                navigate('/general-master/state-list');          
            }
            else{
                //error message
                showSnackbar(responseMessage,"error");
            }
        } catch (error) {
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message || "Error Updating Data", "error");
            //catch error message
        }finally{
            setCircleLoading(false);
        }
        }
    }

  return (
    <>
        <DashboardLayout>
            <Card sx={{ minHeight: 500 }}>
                <CardHeader
                title={(
                    <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                    >
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <IconButton onClick={() => navigate("/general-master/state-list")}>
                                <ArrowBack />
                            </IconButton>
                            <Stack direction="column" spacing={0}>
                                <MaterialTypography variant="h5" fontWeight="medium">
                                    State Details
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    Add New State Details from around the world.
                                </MaterialTypography>
                            </Stack>
                        </Stack>
                    </Stack>
                )}>

                </CardHeader>
                <CardContent>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                            <MaterialBox>
                                <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                    State Name*
                                </MaterialTypography>
                            </MaterialBox>
                            <MaterialInput
                            name="name"
                            placeholder="eg. Tamil Nadu"
                            value={formData.name}
                            onChange={handleChange}
                            error={formData.nameStatus === "error"}
                            success={formData.nameStatus === "success"}
                            disabled={pageMode === "view"}
                            />
                            {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                State Name should be a minimum 1 character & maximum 170 characters long.
                                </FormHelperText>
                            </FormControl>
                            )}
                        </Grid2>
                        <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                            <MaterialBox>
                                <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                    Country Name*
                                </MaterialTypography>
                            </MaterialBox>
                            <MaterialSelect
                            name="countryId"
                            value={formData.countryId}
                            options={countryDropdownOptions}
                            onChange={handleChange}
                            error={formData.countryIdStatus === "error"}
                            success={formData.countryIdStatus === "success"}
                            isDisabled={pageMode === "view"} 
                            />
                        </Grid2>
                        <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                            <MaterialBox>
                                <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                    State Code*
                                </MaterialTypography>
                            </MaterialBox>
                            <MaterialInput
                            name="code"
                            placeholder="eg. TN"
                            value={formData.code}
                            onChange={handleChange}
                            error={formData.codeStatus === "error"}
                            success={formData.codeStatus === "success"}
                            disabled={pageMode === "view"}
                            />
                        </Grid2>
                        {(pageMode === "edit" || pageMode === "view") && (
                        <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                            <MaterialBox>
                                <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                 State ID
                                </MaterialTypography>
                            </MaterialBox>
                            <MaterialInput
                            name="iplCountryId"
                            value={formData?.iplStateId}
                            onChange={handleChange}
                            success={formData?.iplStateIdStatus === "success"}
                            error={formData?.iplStateIdStatus === "error"}
                            disabled
                            />
                        </Grid2>
                        )}
                        <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                            <MaterialBox>
                                <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                    Active
                                </MaterialTypography>
                            </MaterialBox>
                            <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.active}
                                    disabled={pageMode === "view"}
                                    onChange={(e) =>
                                        handleChange({
                                            target: {
                                                name: "active",
                                                value: e.target.checked,
                                            },
                                        })
                                    }
                                    color="primary"
                                />
                            }
                            label={
                                <MaterialTypography variant="caption" fontWeight="bold">
                                    {formData?.active ? "Yes" : "No"}
                                </MaterialTypography>
                            }
                            sx={{ marginLeft: 0 }}
                            />
                        </Grid2>
                    </Grid2>
                </CardContent>
                <MaterialBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                {pageMode === "add" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    onClick={() => navigate("/general-master/state-list")}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleStateAction}
                    >
                    Submit
                    </MaterialButton>
                </>
                )}

                {pageMode==="edit" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    // onClick={handleCancel}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleStateAction}
                    >
                    Update
                    </MaterialButton>
                </>
                )}
                </MaterialBox>
            </Card>
        </DashboardLayout>
        <DashboardFooter>

        </DashboardFooter>
    </>
  )
}

export default StateForm